import * as React from 'react'
import {any as propTypeAny} from 'prop-types'
import {IStore} from '$src/bootstrap/Store'
import {call} from 'redux-saga/effects'
import callEndpoint from '$src/api/sagas/callEndpoint'

function preventToThrow(fn: () => Generator) {
  return function* callAndCatch(...args: any[]): Generator {
    try {
      // @ts-ignore
      return yield call(fn, ...args)
    } catch (e) {
      return Promise.reject(e)
    }
  }
}

export default class Component<Props, State> extends React.Component<
  Props,
  State
> {
  store: IStore
  runSaga: any
  callEndpoint: (apiFn: Function, ...args: any[]) => any

  static contextTypes = {
    store: propTypeAny,
  }

  constructor(props: Props, context: any) {
    super(props)
    this.store = context.store
    this.runSaga = (fn: any, ...args: any[]) => {
      // @ts-ignore
      return this.store.sagaMiddleware.run(preventToThrow(fn), ...args).done
    }

    this.callEndpoint = (apiFn: Function, ...args: any[]) =>
      this.runSaga(function*(): Generator {
        return yield callEndpoint(apiFn, ...args)
      })
  }
}



// WEBPACK FOOTER //
// ./src/handy/Component.tsx